"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Soundcloud24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_2019_2954)" },
            react_1.default.createElement("path", { d: "M6.00002 17.9997H7.49998V8.5541C6.93747 8.7131 6.43048 9.00186 6.00002 9.38132V17.9997ZM3.00001 11.6096V17.9891L3.09673 17.9996H4.49997V11.5998H3.09673L3.00001 11.6096ZM0 14.7986C0 15.9604 0.604533 16.9676 1.49996 17.5294V12.0709C0.604533 12.6319 0 13.6392 0 14.7986ZM9.00003 17.9997H10.5V8.97039C10.0515 8.69061 9.54376 8.50616 9.00003 8.43489V17.9997ZM20.9033 11.5999H20.0595C20.1023 11.3389 20.1293 11.0741 20.1293 10.8004C20.1293 8.1491 18.0495 6.00037 15.4838 6.00037C14.0919 6.00037 12.8513 6.6409 12 7.64434V17.9996H20.9033C22.6125 17.9996 24 16.5671 24 14.7986C24 13.0317 22.6125 11.5999 20.9033 11.5999Z", fill: "#383F49" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_2019_2954" },
                react_1.default.createElement("rect", { width: 24, height: 24, fill: "white" }))));
}
function Soundcloud24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Soundcloud24Svg, Object.assign({}, svgProps)));
}
exports.default = Soundcloud24;
//# sourceMappingURL=Soundcloud24.js.map